import { render } from "./RuleTab.vue?vue&type=template&id=651bdd1c&scoped=true"
import script from "./RuleTab.vue?vue&type=script&lang=js"
export * from "./RuleTab.vue?vue&type=script&lang=js"

import "./RuleTab.vue?vue&type=style&index=0&id=651bdd1c&lang=less&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651bdd1c"]])

export default __exports__